import {useState} from "react";

export const useCustomerArtworkModal = () => {
    const [showModal, setShowModal] = useState<boolean>(false);

    return {
        model: {
            show: showModal,
            toggle: () => setShowModal(!showModal)
        }
    }
}